<template>
  <div class="cards">
    <Card
      v-for="( card, i ) in cards"
      :key="i"
      :component="card.component"
      :options="card.options"
    />
  </div>
</template>

<script>
import Card from './Card';

export default {
  name: 'Cards',
  props: [ 'cards', 'component' ],
  components: { Card, }
}
</script>

<style lang="scss" scoped>
  .cards {
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: auto;
    gap: 10px;
  }

  @include breakpoints(medium) {
    .cards {
      grid-template-columns: 49% 49%;
      grid-auto-rows: 1fr;
      gap: 20px;
    }
  }
</style>